export default __webpack_public_path__ + "static/media/637.2f747718.png";